import ChatBubbleContext from '@components/DevRev/SupportBubbleContext';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { Divider, Grid } from '@mui/material';
import { HELP_LINKS } from '@utils/docs';
import React from 'react';
import { IChatBubbleContext } from 'types/devRev';
import HelpItem from '../../Help/HelpItem';

const HomeFooter: React.FC = () => {
	const { open } = React.useContext<IChatBubbleContext>(ChatBubbleContext);

	return (
		<Grid container rowSpacing={1}>
			<Grid item xs={12} md>
				<HelpItem
					itemKey="documentation"
					url={HELP_LINKS.documentation}
					icon={<SchoolOutlinedIcon />}
				/>
			</Grid>
			<Grid
				item
				xs={1}
				justifyContent="center"
				sx={{
					display: { xs: 'none', sm: 'flex' }
				}}
			>
				<Divider orientation="vertical" />
			</Grid>
			<Grid item xs={12} md>
				<HelpItem
					itemKey="community"
					url={HELP_LINKS.community}
					icon={<LocalLibraryOutlinedIcon />}
				/>
			</Grid>
			<Grid
				item
				xs={1}
				display="flex"
				justifyContent="center"
				sx={{
					display: { xs: 'none', sm: 'flex' }
				}}
			>
				<Divider orientation="vertical" />
			</Grid>
			<Grid item xs={12} md>
				<HelpItem
					itemKey="getHelp"
					onClick={open}
					icon={<LiveHelpOutlinedIcon />}
				/>
			</Grid>
		</Grid>
	);
};

export default HomeFooter;
